import { render, staticRenderFns } from "./Nai5BalanceDetails.vue?vue&type=template&id=51d87173&scoped=true"
import script from "./Nai5BalanceDetails.vue?vue&type=script&lang=js"
export * from "./Nai5BalanceDetails.vue?vue&type=script&lang=js"
import style0 from "./Nai5BalanceDetails.vue?vue&type=style&index=0&id=51d87173&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d87173",
  null
  
)

export default component.exports